import { warning } from '@eastcoal/common/utils/warning'

import { ResourceConfig } from '../../../types/resource'
import { isRoute } from '../../../utils/isRoute'
import { RouterLink } from '../../Link'
import { MenuConfig } from '../interface'

export const transformSiderMenus = (menus: ResourceConfig[]): MenuConfig[] => {
  return menus.map(item => {
    const { key, keys, uuid, title, icon, path, isPage, children } = item
    warning(!title, 'useAntdMenu', '菜单项 title 不能为空')

    const newChildren = children && transformSiderMenus(children)

    warning(
      isRoute(item) && !path,
      'useAntdMenu',
      `菜单项 [${title}] 的 path 不能为空`
    )

    return {
      icon,
      key,
      keys,
      title,
      uuid,
      isPage,
      label: path ? (
        <RouterLink hoverUnderline={false} to={path}>
          {title}
        </RouterLink>
      ) : (
        title
      ),
      children: newChildren
    }
  })
}
